const fieldsNames = {
  _id: '_id',
  client: 'client',
  invoiceLogo: 'settings.logo.filePath',
  revenueNumber: 'revenueNumber',
  quoteNumber: 'quoteNumber',
  color: 'settings.header.color',
  textColor: 'settings.header.textColor',
  doesUnitPriceIncludeVAT: 'settings.doesUnitPriceIncludeVAT',
  user: 'user',
  invoiceDate: 'invoiceDate',
  quoteDate: 'quoteDate',
  dueDate: 'dueDate',
  email: 'user.email',
  phoneNumber: 'user.phoneNumber',
  IBAN: 'user.IBAN',
  SWIFT: 'user.SWIFT',
  name: 'name',
  companyName: 'user.companyName',
  address: 'user.address',
  street: 'user.address.street',
  zip: 'user.address.zip',
  city: 'user.address.city',
  VATNumber: 'user.VATNumber',
  firstName: 'user.firstName',
  lastName: 'user.lastName',
  VATType: 'user.VATType',
  VATReturnFrequency: 'user.VATReturnFrequency',
  clientId: 'clientId',
  currency: 'currency',
  items: 'items',
  itemsCalculations: 'itemsCalculations',
  itemsCalculationsTotalInclVAT:
    'itemsCalculations.calculations.totalAmountInclVAT',
  comments: 'comments',
  conditions: 'conditions',
  termsAndConditions: 'settings.termsAndConditions',
  language: 'settings.language',
  steuernummer: 'user.steuernummer',
  period: 'period',
  status: 'status',
  paymentType: 'paymentType',
  paymentDate: 'paymentDate',
  paymentAmount: 'paymentAmount',
  transactions: 'transactions',
  deliveryDate: 'deliveryDate',
  deliveryPeriod: 'deliveryPeriod',
  type: 'type',
  template: 'settings.templateType',
  taxPeriod: 'taxPeriod',
  usePaymentQrCode: 'settings.usePaymentQrCode',
  paymentQrCode: 'paymentQrCode',
  useCommunication: 'settings.useCommunication',
  communication: 'communication',
  downPayment: 'downPayment',
  useDownpayment: 'settings.useDownpayment',
  din5008: 'din5008',
  recurringData: 'recurringData',
  fontFamily: 'settings.fontFamily',
  fontOption: 'settings._fontOption',
  fontFallback: 'settings._fontFallback',
  reviewStatus: 'accountantReview.reviewStatus',
  includeCopyrightReminder: 'settings.includeCopyrightReminder',
  showDeliveryPeriod: 'settings.showDeliveryPeriod',
  isScheduling: 'isScheduling',
  saveSettings: '_saveSettings',
  pauseReason: 'pauseReason',
  orderReference: 'orderReference',

  // frontend only
  _invalidDocumentNumber: '_invalidDocumentNumber', // used for validating unique document number
  defaultRevenueNumber: 'defaultRevenueNumber',
};

export default fieldsNames;
